(() => {
  const load = (video) => {
    if (!video.hasAttribute('data-furvor-deferred')) return;
    video.removeAttribute('data-furvor-deferred');
    video.querySelectorAll('source[data-furvor-src]').forEach((source) => {
      source.src = source.dataset.furvorSrc;
      source.removeAttribute('data-furvor-src');
    });
    video.load();
    if (video.autoplay) video.play().catch(() => {});
  };
  const init = (root) => {
    const videos = root.querySelectorAll('video[data-furvor-deferred]');
    if (!('IntersectionObserver' in window)) {
      videos.forEach(load);
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        load(entry.target);
      });
    }, { rootMargin: '400px' });
    videos.forEach((video) => observer.observe(video));
    root.querySelectorAll('tpt-video-item').forEach((item) => {
      item.addEventListener('click', () => {
        item.querySelectorAll('video[data-furvor-deferred]').forEach(load);
      }, { capture: true });
    });
  };
  init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
